// =====================================================
// Loading Indicator - Typing Animation
// =====================================================

import React from 'react';

const LoadingIndicator: React.FC = () => {
  return (
    <div className="flex justify-start p-4">
      <div className="bg-gray-100 rounded-2xl px-4 py-3">
        <div className="flex space-x-2">
          <div className="loading-dot"></div>
          <div className="loading-dot"></div>
          <div className="loading-dot"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingIndicator;